export default "__VITE_ASSET__BQIDks2J__"